module.exports = __webpack_public_path__ + "static/img/brees-2011-img-in-copy.47b1a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-img-in-copy.jpg
// module id = wDam
// module chunks = 1